<template>
  <NuxtLink
    :class="[isTop && order ? `top-${order}` : '', isBanned ? 'banned' : '']"
    :to="localePath(`/inventory/${item?.steam64}`)"
    class="list-item card-dark"
  >
    <div class="list-item-left">
      <img
        :src="getImageFromProxy(item?.avatar_url?.replace(/\.(jpe?g)$/i, '_full.$1'), '100:100')"
        alt="User nickname"
        class="user-avatar"
      >
      <p class="user-name ell">
        {{ item?.persona_name }}
      </p>
    </div>
    <div class="list-item-right">
      <p class="list-item-price">
        <Medal
          v-if="isTop"
          :color="order === 1 ? '#D0A94E' : order === 2 ? '#C2D4E1' : '#fdbf99'"
        />
        <svg
          v-if="isBanned"
          class="red"
          height="24"
          width="24"
        >
          <use xlink:href="/icons/sprite.svg#i-ban" />
        </svg>
        <UiPrice
          :decimal="0"
          :price="item?.total_value"
        />
      </p>
      <p class="list-item-count ell">
        <span>{{ Number(item?.items_count).toLocaleString() }} {{
          $t("items").toLocaleLowerCase()
        }}</span>
      </p>
      <i class="i-arrow" />
    </div>
  </NuxtLink>
</template>

<script lang="ts" setup>
import type { GetUserInventoriesUserOutput } from '~/graphql/generated/schema-types';
import Medal from '~/components/Pages/inventory/InventoriesList/Medal.vue';

withDefaults(
  defineProps<{
    isTop?: boolean
    isBanned?: boolean
    order?: number
    item?: GetUserInventoriesUserOutput
  }>(),
  {
    isTop: false,
    isBanned: false,
    order: 0,
  },
);

const localePath = useLocalePath();
</script>

<style lang="scss" scoped>
.list-item {
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px 20px;
  //transition: background 0.3s ease;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  //background: var(--surfaces-high-container);

  &.banned {
    background: linear-gradient(90deg, rgba(255, 87, 87, 0.1) 0%, var(--surfaces-low-container) 70%);
  }

  &:hover,
  &[class^="top-"]:hover {
    background: var(--gr-primary-10);
  }

  &[class^="top-"]:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    width: 5px;
    background: linear-gradient(
            139deg,
            #d0a94e 12.87%,
            #fde276 51.17%,
            #d0a94e 87.84%
    );
  }

  &.top-1 {
    background: linear-gradient(90deg, rgba(253, 205, 82, 0.15) 0%, var(--surfaces-low-container) 70%);

    &:before {
      background: linear-gradient(
              139deg,
              #d0a94e 12.87%,
              #fde276 51.17%,
              #d0a94e 87.84%
      );
    }
  }

  &.top-2 {
    background: linear-gradient(90deg, rgba(194, 212, 225, 0.15) 0%, var(--surfaces-low-container) 70%);

    &:before {
      background: linear-gradient(
              138deg,
              #c2d4e1 16.88%,
              #e8eded 51.58%,
              #abbdc8 78.69%
      );
    }
  }

  &.top-3 {
    background: linear-gradient(90deg, rgba(244, 197, 169, 0.15) 0%, var(--surfaces-low-container) 70%);

    &:before {
      background: linear-gradient(
              138deg,
              #8f6959 12.32%,
              #f4c5a9 53.39%,
              #8f6959 92.85%
      );
    }
  }

  &-left,
  &-right {
    display: flex;
    align-items: center;
    gap: 12px;
    font-size: 16px;
    font-weight: 600;
  }

  &-left {
    .user-avatar {
      width: 40px;
      height: 40px;
      border-radius: 50%;
    }
  }

  &-right {
    gap: 20px;
    color: var(--surfaces-on-surface-variable);

    .list-item-price {
      color: var(--surfaces-on-surface);
      display: flex;
      gap: 8px;
      align-items: center;

      svg {
        margin-bottom: 2px;
      }
    }

    i {
      transform: rotate(270deg);
    }
  }

  .user-name {
    // max-width: 150px;
  }
}

@media screen and (max-width: 600px) {
  .list-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;

    &-left {
      width: 100%;
      padding-right: 30px;
    }

    &-right {
      width: 100%;
      justify-content: space-between;

      .i-arrow {
        position: absolute;
        right: 16px;
        top: 26px;
      }
    }
  }
}
</style>
